import React from "react";

function FreePremiumReportLandingPage({reportData}) {

    const getFreeReport = () => {
        window.open(reportData.pdfUrl);
    }

    const getBranding = () => {
        if (!("company_name" in reportData)) {
            return (
                <>
                    <div className="epimsLogoContainer">
                        <img alt="" className="epimsLogo" src="/epims_logo_small.png" />
                    </div>
                    <div>
                    </div>
                </>
            );
        }
        if (!("logo_url" in reportData)) {
            return (
                <>
                    <div className="epimsLogoContainer">
                        <img alt="" className="epimsLogo" src="/epims_logo_small.png" />
                    </div>
                    <div className="assessorLogoContainer">
                        <p style={{margin: "0"}}>In Association With {reportData.company_name}</p>
                    </div>
                </>
            );
        }
        return (
            <>
                <div className="epimsLogoContainer">
                    <img alt="" className="epimsLogo" src="/epims_logo_small.png" />
                </div>
                <div className="assessorLogoContainer">
                    <p style={{margin: "0", display: "inline"}}>In Association With</p>
                    <img alt="" style={{margin: "0 0 0 10px", display: "inline"}} className="assessorLogo" src={reportData.logo_url} />
                </div>                
            </>
        )
    }

    return (
        <div className="freeReportLandingPage">
            <div className="logosArea">
                <div className="singleColumnLayout">
                    <div className="logos">
                        {getBranding()}
                    </div>
                </div>
            </div>
            <div className="body">
                <div className="singleColumnLayout">
                    <h1 className="onBlue">Download your epIMS Home Energy Report now</h1>
                    <h2 className="onBlue">for {reportData.short_title}</h2>
                    <div className="mainTextLayout mainTextLayoutPremium">
                        <div className="leftCol">
                            <img alt="" onClick={getFreeReport} className="imgPremiumReport" src="/epims premium cover.jpg" />
                        </div>
                        <div className="rightCol">
                            <h2 className="onBlue">Your epIMS home energy report is the ideal document to go alongside your EPC.</h2>
                            <p className="onBlue">You have received this link because it provides access to your personalised epIMS Home Energy Report.</p>
                            <p className="onBlue">The report enables you to compare the impact of different improvement measures, discover grant funding opportunities and understand your legal obligation if you are selling or renting a property</p>
                            <p className="onBlue">This report should prepare you to start on your home energy efficiency improvement journey.</p>
                            <p className="onBlue">Download today.</p>
                        </div>                        
                    </div>
                </div>
                <div className="greenBanner">
                    <div>
                        <p>Download your epIMS Home Energy Report</p>
                    </div>
                    <div>
                        <button onClick={getFreeReport} className="btn btn-primary btn-lg">Download</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FreePremiumReportLandingPage;